import Menu from './Menu'
import { useEffect } from 'react'
import { CorporateFare, EmojiPeople } from '@mui/icons-material'
import MenuItem from './MenuItem'
import { Stage } from '../config/config'
import { loginWithSSO } from '../auth/auth'

export default function UnauthenticatedSidebarMenu(props = {}) {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Menu>
      <MenuItem toBlank={true} 
        href={`https://sso.${Stage === 'prod' ? '' : 'stg.'}connect.coca-cola.com`} 
        title='I Need to Register'
        icon={<EmojiPeople />} />
      <MenuItem 
        onClick={(e) => {loginWithSSO()}}
        title='Login for Internal Users'
        icon={<CorporateFare />} />
    </Menu>
  )
}